import React, { Fragment } from 'react';

const About = () => {
  return (
    <div className='card grid-2'>
      <h1>About this App</h1>

      <div className='card grid-2'>
        <p>App to Search GITHUB Users</p>
        <p>Version 1.0.0</p>
        <p>Developed and Maintained by charan kumar pyla</p>
        <p>Contact: 8522990222</p>
        <p>Email - its.charanp@gmail.com</p>
        <p>Official University mail - pyla.charankumar@vitstudent.ac.in</p>
      </div>
    </div>
  );
};

export default About;
